import React from 'react';

import PropTypes from 'prop-types';

import localize from 'wanderu-i18n/src/localize';

import cgConfig from '../../../../config/carrierguide.locale';
import Quickview from '../../Quickview/Quickview';

import styles from './CarrierQuickview.scss';

const STATS = [
    // view order
    'tripsPerDay',
    'stations',
    'cities',
    'countries',
];
const I18N_KEYS = {
    tripsPerDay: 'carrierTripCount',
    stations: 'carrierStationCount',
    cities: 'carrierCityCount',
    countries: 'carrierCountryCount',
};

function CarrierQuickview(props) {
    const {
        t,
        metrics,
    } = props;
    const stats = metrics
        .sort((m1, m2) => {
            return STATS.indexOf(m1.name) - STATS.indexOf(m2.name);
        })
        .map((metric) => {
            return {
                ...metric,
                name: t(I18N_KEYS[metric.name]),
            };
        });

    return (
        <Quickview
            className={styles.carrierQuickview}
            id="cg-carrier-quickview-title"
            metrics={stats}
            subtitle={t('carrierRoutes')}
            title={t('carrierQuickFacts')}
        />
    );
}

CarrierQuickview.propTypes = {
    carrier: PropTypes.object.isRequired,
};

export { CarrierQuickview };
export default localize(CarrierQuickview, ['i18nNumber', 't'], cgConfig.namespace);
